
//change theme of elements for developments page

const hexToHSL = (H) => {
  // this function is only used in browsers that do not yet support the css color-mix function
  // Convert hex to RGB first
  let r = 0,
    g = 0,
    b = 0;
  if (H.length == 4) {
    r = '0x' + H[1] + H[1];
    g = '0x' + H[2] + H[2];
    b = '0x' + H[3] + H[3];
  } else if (H.length == 7) {
    r = '0x' + H[1] + H[2];
    g = '0x' + H[3] + H[4];
    b = '0x' + H[5] + H[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0;

  if (delta == 0) h = 0;
  else if (cmax == r) h = ((g - b) / delta) % 6;
  else if (cmax == g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  let headTag = document.getElementsByTagName('head')[0];
  let styleTag = document.createElement("style");

  styleTag.innerHTML = `
    :root {
        --hue: ${h}deg;
        --sat: ${s}%;
        --light: ${l}%;
    }
  `;
  headTag.appendChild(styleTag);
};

const applyTheming = () => {
  // get default theme colour from the CSS and put them into local variables
  let themeInputValue = getComputedStyle(document.documentElement).getPropertyValue("--custom-theme-color");

  // now, check the DOM for the presence of any one or more of user-defined colours, and replace the default property
  if (document.querySelector('.main-theme')) {
    themeInputValue = document.querySelector('.main-theme').dataset.themeColor;
    document.documentElement.style.setProperty('--custom-theme-color', themeInputValue);
  }
  // hexToHSL is only required if browsers cannot use color-mix CSS function, which does the job without the need for JS.
  // only the custom theme colour needs this conversion if color-mix is not available
  if (!CSS.supports('color: color-mix(in srgb, white, black)')) {
    hexToHSL(themeInputValue);
    document.documentElement.style.setProperty('--custom-theme-color', themeInputValue);
  }
  if (document.querySelector('.submenu-theme')) {
    let subMenuInputValue = document.querySelector('.submenu-theme').dataset.submenuThemeColor;
    document.documentElement.style.setProperty('--sub-theme-color', subMenuInputValue);
  }
  if (document.querySelector('.alt-background-theme')) {
    let altBgInputValue = document.querySelector('.alt-background-theme').dataset.backgroundThemeColor;
    document.documentElement.style.setProperty('--alt-theme-color', altBgInputValue);
  }
  if (document.querySelector('.property-table-link-color')) {
    let propertyTableLinkColorValue = document.querySelector('.property-table-link-color').dataset.propLinkColor;
    document.documentElement.style.setProperty('--table-link-color', propertyTableLinkColorValue);
  }
};

document.addEventListener('DOMContentLoaded', function(event) {
  applyTheming();
});